import { ROUTESWEB } from "@repo/utils";
import { useAuthStore } from "../../../store/useAuthStore";
import { clearGeniusDeeplinkNavLock } from "./geniusDeeplinkNavLock";
import { releaseGeniusDeeplinkSession } from "./geniusDeeplinkSession";

/** Hard clear used only for explicit Genius error → login flows. */
export function logoutGeniusDeeplinkRestrictedSession(): void {
  clearGeniusDeeplinkNavLock();
  releaseGeniusDeeplinkSession();
  useAuthStore.getState().logout(false);
}

export function getGeniusDeeplinkLogoutRedirectPath(): string {
  return `/${ROUTESWEB.AUTH.INTRO}`;
}
